import { render, staticRenderFns } from "./UserProfilePaymentHistory.vue?vue&type=template&id=976455d8"
import script from "./UserProfilePaymentHistory.vue?vue&type=script&lang=js"
export * from "./UserProfilePaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports